var _circle, _circle2, _circle3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerInHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 104,
    r: 102,
    fill: "#F1FBFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 104,
    r: 102.718,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.43662
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3253_8240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 204,
    height: 204
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 104,
    r: 102,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3253_8240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.818 191.124C187.818 191.124 135.893 161.348 131.273 154.098C126.653 146.847 97.3192 109.71 91.8813 104.737C86.4434 99.7629 80.5634 96.5798 77.3802 101.111C74.1971 105.643 76.9381 107.898 79.5907 109.71C82.1819 111.188 84.9145 112.402 87.7476 113.336L85.9349 117.867C84.2094 119.279 82.853 121.089 81.9827 123.142C81.1124 125.194 80.7543 127.427 80.9392 129.649C81.8455 136.9 84.1224 156.817 88.1897 160.442C92.2571 164.067 116.728 173.13 116.728 173.13C116.728 173.13 159.148 225.675 167.304 238.341C175.461 251.007 182.778 251.029 187.199 251.936C191.62 252.842 217.506 244.353 209.304 220.347C201.103 196.341 187.818 191.124 187.818 191.124Z",
    fill: "#FFFCF7",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9648 63.5767C79.9648 63.5767 86.5964 98.3925 89.249 114.242C91.9017 130.091 90.5974 151.821 91.4595 160.906",
    fill: "#FFFCF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9648 63.5767C79.9648 63.5767 86.5964 98.3925 89.249 114.242C91.9017 130.091 90.5974 151.821 91.4595 160.906",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0087 59.6636C76.0087 59.6636 57.7939 64.6815 57.7939 74.3415C57.7939 81.3488 65.7298 80.6194 69.5982 77.0162C70.8582 75.8446 78.4403 62.3383 78.5951 62.4488C78.7498 62.5594 75.6992 60.9678 76.0087 59.6636Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0189 63.0464C78.0189 63.0464 73.2662 81.3275 81.622 86.1464C87.701 89.6612 91.0168 82.4327 89.8452 77.3043C89.4473 75.6464 81.4894 62.3833 81.7325 62.2285C81.9757 62.0738 78.9473 64.0191 78.0189 63.0464Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9121 63.046C81.9121 63.046 95.3521 76.3091 103.73 71.4681C109.787 67.9754 105.189 61.4765 100.127 59.907C98.5131 59.4207 83.0394 59.686 83.0394 59.3986C83.0394 59.1113 83.2384 62.7144 81.9121 63.046Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8565 59.6636C83.8565 59.6636 102.071 54.6457 102.071 45.0078C102.071 37.9783 94.1355 38.7078 90.2671 42.3331C89.0071 43.4825 81.425 57.011 81.2702 56.8783C81.1155 56.7457 84.2323 58.3594 83.8565 59.6636Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9103 56.2823C81.9103 56.2823 86.6629 38.0233 78.3071 33.2044C72.2282 29.6896 68.9124 36.9181 70.084 42.0465C70.4819 43.7044 78.4397 56.9454 78.1966 57.1002C77.9534 57.2549 80.9819 55.3318 81.9103 56.2823Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0207 56.282C78.0207 56.282 64.5807 43.0189 56.2028 47.8599C50.1459 51.3747 54.7439 57.8736 59.806 59.421C61.4197 59.9294 76.8933 59.6641 76.8933 59.9294C76.8933 60.1946 76.6944 56.6136 78.0207 56.282Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9657 63.5545C82.1144 63.5545 83.8562 61.8126 83.8562 59.664C83.8562 57.5153 82.1144 55.7734 79.9657 55.7734C77.8171 55.7734 76.0752 57.5153 76.0752 59.664C76.0752 61.8126 77.8171 63.5545 79.9657 63.5545Z",
    fill: "#EB996E",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.199 154.098C128.199 154.098 124.64 128.677 121.855 123.747C119.07 118.818 101.032 102.018 96.9425 97.9502C92.853 93.8829 89.692 85.7039 86.9951 92.5123C84.2983 99.3208 86.0888 102.924 91.9688 109.71C97.8488 116.497 102.38 119.68 102.38 121.05C102.38 122.421 101.474 142.338 103.751 148.218C106.028 154.098 115.069 158.629 115.069 158.629",
    fill: "#FFFCF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.199 154.098C128.199 154.098 124.64 128.677 121.855 123.747C119.07 118.818 101.032 102.018 96.9425 97.9502C92.853 93.8829 89.692 85.7039 86.9951 92.5123C84.2983 99.3208 86.0888 102.924 91.9688 109.71C97.8488 116.497 102.38 119.68 102.38 121.05C102.38 122.421 101.474 142.338 103.751 148.218C106.028 154.098 115.069 158.629 115.069 158.629",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5992 118.773C90.5992 118.773 89.7813 118.287 88.3887 117.602C83.9676 115.391 74.3076 110.97 71.5223 114.706C67.8971 119.68 69.3118 124.211 73.335 126.93C79.7199 130.273 86.6019 132.564 93.716 133.717C96.9434 133.717 102.381 124.653 90.5992 118.773Z",
    fill: "#FFFCF7",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.476 133.805C88.476 133.805 87.7244 133.341 86.5086 132.7C82.4854 130.489 73.5328 126.422 71.0349 130.003C67.697 134.645 68.957 138.845 72.6928 141.409C78.5698 144.531 84.9161 146.674 91.4823 147.754C94.3338 147.754 99.3297 139.309 88.476 133.805Z",
    fill: "#FFFCF7",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0754 148.041C89.0754 148.041 88.5006 147.687 87.5501 147.179C84.4333 145.543 77.4922 142.316 75.5248 144.968C74.9395 145.595 74.5025 146.346 74.2461 147.164C73.9898 147.983 73.9205 148.848 74.0436 149.697C74.1667 150.546 74.4789 151.356 74.9572 152.068C75.4355 152.78 76.0676 153.376 76.8069 153.81C81.3564 156.231 86.2688 157.895 91.3522 158.74C93.6954 158.85 97.4754 152.285 89.0754 148.041Z",
    fill: "#FFFCF7",
    stroke: "#263238",
    strokeWidth: 1.23527,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerInHand);
export default __webpack_public_path__ + "static/media/flower_in_hand.fcf0a416affeb35c6674c763075b18fe.svg";
export { ForwardRef as ReactComponent };